import Cookies from "universal-cookie";
import CryptoJS from "crypto-js";
import axios from "axios";
import { of } from "rxjs";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import swal from "sweetalert";
import * as XLSX from "xlsx";
import DataTable from "datatables.net";

export const renderTabTitle = async (titlesTabs, pasos, idSeleccionado) => {
  let numDocsMap = [];

  if (idSeleccionado != null) {
    const data = new FormData();
    data.append(
      "validacion",
      JSON.stringify({
        sesion: getDecodedCookie("sesion"),
        id: getDecodedCookie("id"),
      }),
    );
    data.append("idsel", idSeleccionado);
    data.append("pasos", pasos);

    const respuesta = await axios.post(
      getApiUrl(window.location.origin) + "/runciccfg/getNumDocs",
      data,
    );
    if (respuesta.data.numdocs) {
      numDocsMap = respuesta.data.numdocs;
    }
  }

  return titlesTabs.map((tab, index) => {
    const title = index + 1 + "-" + tab.tipo;
    if (typeof title !== "string") {
      return title;
    }

    const paso = index + 1;
    const numDocs = numDocsMap[paso] || 0;
    const enlace = document.getElementById(`tab1-tab-tab_${paso}`);
    // if(enlace){
    //     if(parseInt(numDocs) > 0){
    //         // Verde
    //         enlace.style.backgroundColor = '#28a745';
    //         enlace.style.borderColor = '#28a745';
    //         enlace.style.color = '#fff';
    //     }else{
    //         // Azul
    //         enlace.style.backgroundColor = '#007bff';
    //         enlace.style.borderColor = '#007bff';
    //         enlace.style.color = '#fff';
    //     }
    //     enlace.style.borderRadius = '0.25rem';
    //     enlace.style.display = 'block';
    //     enlace.style.padding = '0.5rem 1rem';
    // }

    const match = title.match(/^(\d+)-(\w+)\s-\s(.+)/);
    if (match) {
      const [_, number, abbreviation, description] = match;
      return (
        <Tooltip
          position="bottom"
          animation="fade"
          distance="20"
          arrow={true}
          title={description}>
          <div className="tab-title">
            <span className="number">{number}</span>
            <span className="abbreviation">
              -{abbreviation}({numDocs})
            </span>
          </div>
        </Tooltip>
      );
    }
    return title;
  });
};

export const getIcono = (ext) => {
  let conf = [];
  let confIco = [];
  switch (ext) {
    case "pdf":
      conf["icono"] = "far fa-file-pdf fa-8x";
      conf["color"] = "#dd4b39";
      break;
    case "dwg":
      conf["icono"] = "fal fa-map fa-8x";
      conf["color"] = "#ffc107";
      break;
    case "doc":
    case "docx":
      conf["icono"] = "far fa-file-word fa-8x";
      conf["color"] = "#3c8dbc";
      break;
    case "xls":
    case "xlsx":
    case "xlsm":
      conf["icono"] = "far fa-file-excel fa-8x";
      conf["color"] = "#00a65a";
      break;
    default:
      conf["icono"] = "fal fa-file fa-8x";
      conf["color"] = "#3c8dbc";
      break;
  }

  return conf;
};

export const getIconoTable = (ext) => {
  let conf = [];
  let confIco = [];
  switch (ext.toLowerCase()) {
    case "pdf":
      conf["icono"] = "far fa-file-pdf fa-2x";
      conf["color"] = "#dd4b39";
      break;
    case "dwg":
      conf["icono"] = "fal fa-map fa-2x";
      conf["color"] = "#ffc107";
      break;
    case "doc":
    case "docx":
      conf["icono"] = "far fa-file-word fa-2x";
      conf["color"] = "#3c8dbc";
      break;
    case "xls":
    case "xlsx":
    case "xlsm":
      conf["icono"] = "far fa-file-excel fa-2x";
      conf["color"] = "#00a65a";
      break;
    case "deleted":
      conf["icono"] = "far fa-trash-alt fa-2x";
      conf["color"] = "#000000";
      break;
    default:
      conf["icono"] = "fal fa-file fa-2x";
      conf["color"] = "#3c8dbc";
      break;
  }

  return conf;
};

export const emailIsValid = (email) => {
  return /\S+@\S+\.\S+/.test(email);
};

export const setDeleteInputError = (valido, input) => {
  if (valido == 0) {
    if (!input.classList.contains("is-valid")) {
      input.classList.add("is-valid");
      input.classList.remove("is-invalid");
    }
  } else if (valido == 1) {
    if (!input.classList.contains("is-invalid")) {
      input.classList.add("is-invalid");
      input.classList.remove("is-valid");
    }
  }
};

export const deleteClass = (clase) => {
  let deleteClass = document.querySelectorAll(`.${clase}`);
  for (let i = 0; i < deleteClass.length; i++) {
    deleteClass[i].classList.remove(clase);
  }
};

export function getTreeJson(data, keysTrad, acumulado) {
  if (isArray(data)) {
    recursiveArray(data, keysTrad, acumulado);
  } else if (typeof data === "object" && data !== null) {
    recursiveObject(data, keysTrad, acumulado);
  }

  return acumulado;
}

function recursiveArray(data, keysTrad, acumulado) {
  for (let i = 0; i < data.length; i++) {
    if (typeof data[i] === "object") {
      recursiveObject(data[i], keysTrad, acumulado);
    }
  }
}

function recursiveObject(data, keysTrad, acumulado) {
  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      const existe = keysTrad.filter((keyTrad) => keyTrad === key);
      if (existe.length > 0) {
        if (!acumulado.includes(data[existe[0]])) {
          if (typeof data[existe[0]] !== "object") {
            if (data[existe[0]] !== "") acumulado.push(data[existe[0]]);
          }
        }
      }
      getTreeJson(data[key], keysTrad, acumulado);
    }
  }
}

/*
export function translateTreeJson(data, traducciones){

    if (isArray(data)) {
        translateRecursiveArray(data, traducciones);
    } else if ((typeof data === 'object') && (data !== null)) {
        translateRecursiveObject(data, traducciones);
    }else{
        const tra = traducciones.filter( t => t["ori"] === data);
        if( tra.length > 0 ){
            data = tra[0]["tra"];
        }
    }
    
    return data;
}

function translateRecursiveArray(data,traducciones){

    for(let i=0; i<data.length; i++){
        if( typeof data[i] === "object" ){
            translateRecursiveObject(data[i], traducciones);
        }
    }
}

function translateRecursiveObject(data, traducciones) {

    for (var key in data) {
        if (data.hasOwnProperty(key)) {
               const res = translateTreeJson(data[key], traducciones);
               if( res != "" ){
                   data[key] = res;
               }
        }
    }
}

*/

export function translateTreeJson(data, traducciones, keysTrad) {
  if (isArray(data)) {
    translateRecursiveArray(data, traducciones, keysTrad);
  } else if (typeof data === "object" && data !== null) {
    translateRecursiveObject(data, traducciones, keysTrad);
  } else {
    const tra = traducciones.filter((t) => t["ori"] === data);
    if (tra.length > 0) {
      data = tra[0]["tra"];
    }
  }

  return data;
}

function translateRecursiveArray(data, traducciones, keysTrad) {
  for (let i = 0; i < data.length; i++) {
    if (typeof data[i] === "object") {
      translateRecursiveObject(data[i], traducciones, keysTrad);
    }
  }
}

function translateRecursiveObject(data, traducciones, keysTrad) {
  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      const res = translateTreeJson(data[key], traducciones, keysTrad);
      if (res != "") {
        const existe = keysTrad.filter((keyTrad) => keyTrad === key);
        if (existe.length > 0) {
          data[key] = res;
        }
      }
    }
  }
}

export function isArray(o) {
  return Object.prototype.toString.call(o) === "[object Array]";
}

/***** FECHAS Y HORAS *****/
export const dateSqlToLocal = (fecha, local = "es") => {
  let nuevafecha;
  if (fecha !== "" && fecha != "0000-00-00T00:00" && fecha !== "nullT00:00") {
    const CurrentDate = fecha + ":00";
    let data = new Date(CurrentDate);
    let month = data.getMonth() + 1;
    let day = data.getDate();
    let year = data.getFullYear();
    if (day <= 9) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    if (local == null || local == "es") {
      nuevafecha = day + "/" + month + "/" + year;
    }
    if (local == "en") {
      nuevafecha = year + "-" + month + "-" + day;
    }
    return nuevafecha;
  } else {
    nuevafecha = "";
    return nuevafecha;
  }
};

export const getFechaHoraActual = () => {
  let f = new Date();
  let mes = f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1;
  let dia = f.getDate() < 10 ? "0" + f.getDate() : f.getDate();
  let hora = f.getHours() < 10 ? "0" + f.getHours() : f.getHours();
  let minutos = f.getMinutes() < 10 ? "0" + f.getMinutes() : f.getMinutes();
  let segundos = f.getSeconds() < 10 ? "0" + f.getSeconds() : f.getSeconds();

  let ahora =
    hora +
    ":" +
    minutos +
    ":" +
    segundos +
    " " +
    dia +
    "/" +
    mes +
    "/" +
    f.getFullYear();

  return ahora;
};

export const getFechaHoraActualSql = () => {
  let f = new Date();
  let mes = f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1;
  let dia = f.getDate() < 10 ? "0" + f.getDate() : f.getDate();
  let hora = f.getHours() < 10 ? "0" + f.getHours() : f.getHours();
  let minutos = f.getMinutes() < 10 ? "0" + f.getMinutes() : f.getMinutes();
  let segundos = f.getSeconds() < 10 ? "0" + f.getSeconds() : f.getSeconds();

  let ahora =
    f.getFullYear() +
    "-" +
    mes +
    "-" +
    dia +
    "T" +
    hora +
    ":" +
    minutos +
    ":" +
    segundos;

  return ahora;
};

export const getFechaHoraActualState = () => {
  let f = new Date();
  let mes = f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1;
  let dia = f.getDate() < 10 ? "0" + f.getDate() : f.getDate();
  let hora = f.getHours() < 10 ? "0" + f.getHours() : f.getHours();
  let minutos = f.getMinutes() < 10 ? "0" + f.getMinutes() : f.getMinutes();
  let segundos = f.getSeconds() < 10 ? "0" + f.getSeconds() : f.getSeconds();

  let ahora =
    dia +
    "/" +
    mes +
    "/" +
    f.getFullYear() +
    " " +
    hora +
    ":" +
    minutos +
    ":" +
    segundos;

  return ahora;
};

export const getAhoraInputDateTimeLocal = () => {
  let f = new Date();
  let mes = f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1;
  let dia = f.getDate() < 10 ? "0" + f.getDate() : f.getDate();
  let hora = f.getHours() < 10 ? "0" + f.getHours() : f.getHours();
  let minutos = f.getMinutes() < 10 ? "0" + f.getMinutes() : f.getMinutes();
  let segundos = f.getSeconds() < 10 ? "0" + f.getSeconds() : f.getSeconds();

  let ahora =
    f.getFullYear() + "-" + mes + "-" + dia + " " + hora + ":" + minutos;

  return ahora;
};

export const getAhoraddmmyyyy = () => {
  let f = new Date();
  let mes = f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1;
  let dia = f.getDate() < 10 ? "0" + f.getDate() : f.getDate();

  let ahora = dia + "/" + mes + "/" + f.getFullYear();

  return ahora;
};

export const getAhorayyyymmdd = () => {
  let f = new Date();
  let mes = f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1;
  let dia = f.getDate() < 10 ? "0" + f.getDate() : f.getDate();

  let ahora = f.getFullYear() + "-" + mes + "-" + dia;

  return ahora;
};

export const diffDatesToString = (
  fecha1,
  fecha2,
  traduction,
  soloFecha,
  returnMensaje,
) => {
  let alcance = 0;
  let f = new Date();
  let mes = f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1;
  let dia = f.getDate() < 10 ? "0" + f.getDate() : f.getDate();
  let anho = f.getFullYear();
  fecha2 = anho + "-" + mes + "-" + dia + "T00:00";

  if (
    fecha1 !== "" &&
    fecha2 !== "" &&
    fecha1 !== undefined &&
    fecha2 !== undefined &&
    fecha1 != "0000-00-00T00:00" &&
    fecha2 != "0000-00-00T00:00" &&
    fecha1 != null &&
    fecha2 != null
  ) {
    if (soloFecha) {
      fecha1 = fecha1.split("T")[0] + "T00:00";
      // fecha2 = fecha2.split("T")[0]+"T00:00";
      // fecha2 = anho+"-"+mes+"-"+dia+"T00:00";
      alcance = 3;
    } else {
      alcance = 6;
    }
    const fec1 = new Date(fecha1);
    const fec2 = new Date(fecha2);

    const message = getNiceTime(
      fec1,
      fec2,
      alcance,
      true,
      traduction,
      returnMensaje,
    );
    return message;
  } else {
    return "";
  }
};

function getNiceTime(
  fromDate,
  toDate,
  levels,
  prefix,
  traduction,
  returnMensaje,
) {
  var lang = {
      "date.past": `${traduction.past.title} {0}`,
      "date.future": `${traduction.future.title} {0}`,
      "date.now": `${traduction.now.title}`,
      "date.year": `{0} ${traduction.year.title}`,
      "date.years": `{0} ${traduction.years.title}`,
      "date.years.prefixed": `{0} ${traduction.years.title}`,
      "date.month": `{0} ${traduction.month.title}`,
      "date.months": `{0} ${traduction.months.title}`,
      "date.months.prefixed": `{0} ${traduction.months.title}`,
      "date.day": `{0} ${traduction.day.title}`,
      "date.days": `{0} ${traduction.days}`,
      "date.days.prefixed": `{0} ${traduction.days.title}`,
      "date.hour": `{0} ${traduction.hour.title}`,
      "date.hours": `{0} ${traduction.hours.title}`,
      "date.hours.prefixed": `{0} ${traduction.hours.title}`,
      "date.minute": `{0} ${traduction.minute.title}`,
      "date.minutes": `{0} ${traduction.minutes.title}`,
      "date.minutes.prefixed": `{0} ${traduction.minutes.title}`,
      "date.second": `{0} ${traduction.second.title}`,
      "date.seconds": `{0} ${traduction.seconds.title}`,
      "date.seconds.prefixed": `{0} ${traduction.seconds.title}`,
    },
    langFn = function (id, params) {
      var returnValue = lang[id] || "";
      if (params) {
        for (var i = 0; i < params.length; i++) {
          returnValue = returnValue.replace("{" + i + "}", params[i]);
        }
      }
      return returnValue;
    },
    toDate = toDate ? toDate : new Date(),
    diff = fromDate - toDate,
    past = diff < 0 ? true : false,
    diff = diff < 0 ? diff * -1 : diff,
    date = new Date(new Date(1970, 0, 1, 0).getTime() + diff),
    returnString = "",
    count = 0,
    years = date.getFullYear() - 1970;

  if (years > 0) {
    var langSingle = "date.year" + (prefix ? "" : ""),
      langMultiple = "date.years" + (prefix ? ".prefixed" : "");
    returnString +=
      (count > 0 ? ", " : "") +
      (years !== 1
        ? langFn(langMultiple, [years])
        : langFn(langSingle, [years]));
    count++;
  }

  var months = date.getMonth();
  if (count < levels) {
    var langSingle = "date.month" + (prefix ? "" : ""),
      langMultiple = "date.months" + (prefix ? ".prefixed" : "");
    returnString +=
      (count > 0 ? ", " : "") +
      (months !== 1
        ? langFn(langMultiple, [months])
        : langFn(langSingle, [months]));
    count++;
  } else {
    if (count > 0) count = 99;
  }

  var days = date.getDate() - 1;
  if (count < levels) {
    var langSingle = "date.day" + (prefix ? "" : ""),
      langMultiple = "date.days" + (prefix ? ".prefixed" : "");
    returnString +=
      (count > 0 ? ", " : "") +
      (days !== 1 ? langFn(langMultiple, [days]) : langFn(langSingle, [days]));
    count++;
  } else {
    if (count > 0) count = 99;
  }

  var hours = date.getHours();
  if (count < levels) {
    var langSingle = "date.hour" + (prefix ? "" : ""),
      langMultiple = "date.hours" + (prefix ? ".prefixed" : "");
    returnString +=
      (count > 0 ? ", " : "") +
      (hours !== 1
        ? langFn(langMultiple, [hours])
        : langFn(langSingle, [hours]));
    count++;
  } else {
    if (count > 0) count = 99;
  }

  var minutes = date.getMinutes();
  if (count < levels) {
    var langSingle = "date.minute" + (prefix ? "" : ""),
      langMultiple = "date.minutes" + (prefix ? ".prefixed" : "");
    returnString +=
      (count > 0 ? ", " : "") +
      (minutes !== 1
        ? langFn(langMultiple, [minutes])
        : langFn(langSingle, [minutes]));
    count++;
  } else {
    if (count > 0) count = 99;
  }

  var seconds = date.getSeconds();
  if (count < levels) {
    var langSingle = "date.second" + (prefix ? "" : ""),
      langMultiple = "date.seconds" + (prefix ? ".prefixed" : "");
    returnString +=
      (count > 0 ? ", " : "") +
      (seconds !== 1
        ? langFn(langMultiple, [seconds])
        : langFn(langSingle, [seconds]));
    count++;
  } else {
    if (count > 0) count = 99;
  }

  if (prefix) {
    if (
      returnString == "" ||
      (years === 0 &&
        months === 0 &&
        days === 0 &&
        hours === 0 &&
        minutes === 0)
    ) {
      returnString = langFn("date.now");
      if (!returnMensaje) {
        return "now";
      }
    } else if (past) {
      returnString = langFn("date.past", [returnString]);
      if (!returnMensaje) {
        return "past";
      }
    } else {
      returnString = langFn("date.future", [returnString]);
      if (!returnMensaje) {
        return "future";
      }
    }
  }
  return returnString;
}

export const dateFormatByLocale = (date, idioma = "es") => {
  const mes =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  const dia = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

  return idioma == "en"
    ? `${date.getFullYear()}-${mes}-${dia}`
    : `${dia}/${mes}/${date.getFullYear()}`;
};

export const filtrosToWhere = (data) => {
  let where = "";
  let condiciones = [];

  for (const [key, value] of Object.entries(data)) {
    let condicion = "";
    if (key != "plantilla" && key != "destinatarios" && key != "id") {
      if (!key.includes("filtro")) {
        let aux = key.split("-");
        let filtro = data[`${aux[0]}-filtro-${aux[1]}`];

        condicion = ` ${aux[1]} ${filtro} '${value}'`;

        if (
          condicion.includes("igual") ||
          condicion.includes("distinto") ||
          condicion.includes("contiene") ||
          condicion.includes("nocontiene") ||
          condicion.includes("todos")
        ) {
          condicion = translateCondicion(condicion, filtro, value);
        }

        if (condicion != "") {
          condiciones.push(condicion);
        }
      }
    }
  }

  for (let i = 0; i < condiciones.length; i++) {
    if (i == 0) {
      where += ` ${condiciones[i]} `;
    } else {
      where += ` AND ${condiciones[i]} `;
    }
  }

  return where;
};

function translateCondicion(condicion, filtro, value) {
  if (filtro == "igual") {
    condicion = condicion.replace("igual", "=");
  }
  if (filtro == "distinto") {
    condicion = condicion.replace("distinto", "<>");
  }
  if (filtro == "contiene") {
    let aux = condicion.split("contiene");
    condicion = `${aux[0]} LIKE '%${value}%' `;
  }
  if (filtro == "nocontiene") {
    let aux = condicion.split("nocontiene");
    condicion = `${aux[0]} NOT LIKE '%${value}%' `;
  }
  if (filtro == "todos") {
    condicion = "";
  }

  return condicion;
}

export const txtFalsoSql = (sql, variables) => {
  let where = "";
  let condiciones = [];
  if (variables.length > 0) {
    let vars = JSON.parse(variables);
    vars.map((variable, index, arr) => {
      let condicion = "";
      let value = "XXXX";
      let filtro = "";
      if (variable.condef != "") {
        filtro = variable.condef;
      } else {
        filtro = "CONDICION";
      }
      condicion = ` ${variable.idcon} ${filtro} '${value}'`;
      if (
        condicion.includes("igual") ||
        condicion.includes("distinto") ||
        condicion.includes("contiene") ||
        condicion.includes("nocontiene") ||
        condicion.includes("todos")
      ) {
        condicion = translateCondicion(condicion, filtro, value);
      }

      if (condicion != "") {
        condiciones.push(condicion);
      }
    });

    for (let i = 0; i < condiciones.length; i++) {
      if (i == 0) {
        where += ` ${condiciones[i]} `;
      } else {
        where += ` AND ${condiciones[i]} `;
      }
    }
  }

  if (sql.includes("******FILTRO******")) {
    // sql = sql.replace("******FILTRO******", where);
    sql = MiReplaceAll(sql, "******FILTRO******", where);
  }

  return sql;
};

export const MiReplaceAll = (texto, search, replaceWith) => {
  if (texto != undefined && texto != null && texto != "") {
    return (texto = texto.split(search).join(replaceWith));
  } else {
    return "";
  }
};

export const ReplaceTextsReports = async (texto, formulario, appCryptCom) => {
  const cookies = new Cookies();
  let idReg;
  const usu_actual = getDecodedCookie("id");

  if (texto.includes("reg_actual")) {
    if (formulario.id == "") {
      idReg = 0;
    } else {
      idReg = formulario.id;
    }
    texto = MiReplaceAll(texto, "reg_actual", idReg);
  }
  if (texto.includes("usu_actual")) {
    texto = MiReplaceAll(texto, "usu_actual", usu_actual);
  }
  if (texto.includes("api_actual")) {
    texto = MiReplaceAll(
      texto,
      "api_actual",
      getApiUrl(window.location.origin),
    );
  }
  if (texto.includes("home_actual")) {
    texto = MiReplaceAll(texto, "home_actual", window.location.origin);
  }

  if (texto.includes("centros_usu")) {
    const data = new FormData();
    const validacion = JSON.stringify({
      sesion: getDecodedCookie("sesion"),
      id: usu_actual,
    });
    const filter = await encryptData("filcen", appCryptCom);
    data.append("validacion", validacion);
    data.append("filter", filter);
    data.append("onlyids", true);

    const respuesta = await axios.post(
      getApiUrl(window.location.origin) + "/filters/getFilter",
      data,
    );
    const valuesString = respuesta.data.map((item) => item.id).join(",");
    texto = MiReplaceAll(texto, "centros_usu", valuesString);
  }
  return texto;
};

export const createTxtFiltrosSearch = (vars) => {
  const condiciones = [];

  if (vars) {
    const elementos = vars.children;

    for (let i = 0; i < elementos.length; i++) {
      let label = "";
      let filtro = "";
      let valor = "";
      let condicion;
      if (elementos[i].classList.contains("filterVar")) {
        label = elementos[i].children[0].innerText;
        filtro = elementos[i].children[1].innerText;
        if (filtro != "Todos") {
          let inputEstaCondicion = elementos[i].nextSibling;
          if (inputEstaCondicion) {
            if (inputEstaCondicion.children.length == 1) {
              //Es un select
              valor = inputEstaCondicion.children[0].innerText;
            }
            if (inputEstaCondicion.children.length == 2) {
              //Es un campo texto, number o fecha
              inputEstaCondicion.children[1].children[0].type ==
              "datetime-local"
                ? (valor = dateSqlToLocal(
                    inputEstaCondicion.children[1].children[0].value,
                  ))
                : (valor = inputEstaCondicion.children[1].children[0].value);
            }
          }
        }
        condiciones.push({ cond: `${label} ${filtro} ${valor}` });
      }
    }
  }

  return condiciones;
};

export const getIndexUrl = (menuMode, origen = null) => {
  let url = "/inicio";
  if (menuMode && !menuMode.startsWith("/")) {
    switch (menuMode) {
      case "checklist":
        // if( getDecodedCookie('nivel') == 4  ){
        //     url = "/checklisttrab";
        // }else{
        //     url = "/checklist";
        // }
        url = "/checklist";
        break;
      default:
        if (origen == "wizardchecklist") {
          // if( getDecodedCookie('nivel') == 4  ){
          //     url = "/checklisttrab";
          // }else{
          //     url = "/checklist";
          // }
          url = "/checklist";
        } else {
          url = "/inicio";
        }

        break;
    }
  } else {
    if (menuMode) {
      url = menuMode;
    }
  }
  return url;
};

export const bootStrapAlertClassToColor = (classBST) => {
  let color = "";

  switch (classBST) {
    case "alert-secondary":
      color = "#888888";
      break;
    case "alert-success":
      color = "#28a745";
      break;
    case "alert-warning":
      color = "#ffc107";
      break;
    case "alert-danger":
      color = "#dc3545";
      break;
    case "alert-primary":
      color = "#007bff";
      break;
  }

  return color;
};

export const getApiUrl = (project) => {
  let api = "";

  project = project.includes('//localhost:') == true ? "islocalhost" : project;

  switch (project) {
    // Localhost
    // case "http://localhost:3000":
    // case "https://localhost:3000":
    // case "http://localhost:3001":
    // case "https://localhost:3001":
    // case "http://localhost:3002":
    // case "https://localhost:3002":
    case "http://iishost.perizia.es:3000":
    case "islocalhost": 
      api = process.env.REACT_APP_API_URL;
      break;
    // Upkeep
    case "http://login.upkeep.periziaonline.es":
    case "https://login.upkeep.periziaonline.es":
      api = "https://api.upkeep.periziaonline.es";
      break;
    // Polarbay
    case "http://home.polarbay.argos-coterena.com":
    case "https://home.polarbay.argos-coterena.com":
      api = "https://api.polarbay.argos-coterena.com";
      break;
    // Polarseafish
    case "http://home.polarseafish.argos-coterena.com":
    case "https://home.polarseafish.argos-coterena.com":
      api = "https://api.polarseafish.argos-coterena.com";
      break;
    // Demo
    case "http://home.demo.argos-coterena.com":
    case "https://home.demo.argos-coterena.com":
      api = "https://api.demo.argos-coterena.com";
      break;
    // Pereira
    case "http://home.pereira.argos-coterena.com":
    case "https://home.pereira.argos-coterena.com":
      api = "https://api.pereira.argos-coterena.com";
      break;
    // Rampesca
    case "http://home.rampesca.argos-coterena.com":
    case "https://home.rampesca.argos-coterena.com":
      api = "https://api.rampesca.argos-coterena.com";
      break;
    // Magallanes
    case "http://home.magallanes.argos-coterena.com":
    case "https://home.magallanes.argos-coterena.com":
      api = "https://api.magallanes.argos-coterena.com";
      break;
    // MAINTENANCE LOCAL PRUEBAS ISSHOST 2
    case "http://home.argos.local":
    case "https://home.argos.local":
      api = "http://api.argos.local";
      break;
    // ***** COTERENA *****
    case "http://home.activos.argos-coterena.com":
    case "https://home.activos.argos-coterena.com":
      api = "https://api.activos.argos-coterena.com";
      break;
    // ***** TUNASAFE DEV *****
    case "http://home.dev.tunasafe.net":
    case "https://home.dev.tunasafe.net":
      api = "https://api.dev.tunasafe.net";
      break;
    // ***** El front de alarmas se gestiona a través del api de activos *****
    case "http://home.alarm.argos.aitodetec.com":
    case "https://home.alarm.argos.aitodetec.com":
      api = "https://api.activos.argos-coterena.com";
      break;
    default:
      // CON ESTE DEFAULT LOS UNICOS CASE QUE HARIAN FALTA SON EL UPKEEP Y EL DE ALARMAS
      api = project.replace("//home.", "//api.");
      break;
  }

  return api;
};

export const getTitle = (options, addText) => {
  if (window.location.origin.includes(".tunasafe.net")) {
    return addText != ""
      ? options.tunasafe.title + " - " + addText
      : options.tunasafe.title;
  } else {
    return addText != ""
      ? options.maintenance.title + " - " + addText
      : options.maintenance.title;
  }
};

export const stringToHtml = (str) => {
  return { __html: str };
};

export const getLinkReadOnly = (optionCfg) => {
  if (optionCfg == "1") {
    return "";
  } else {
    return "/readonly";
  }
};

export const axiosPost = async (url, data, cancelToken) => {
  let respuesta;

  if (cancelToken) {
    respuesta = await axios.post(url, data, { cancelToken: cancelToken });
  } else {
    respuesta = await axios.post(url, data);
  }

  return respuesta;
};

export const getPantDocFromNivel = (nivel, forceEdirap = false, largeComp = false) => {
  let pantalla = "";

  if (forceEdirap == true) {
    pantalla = "/edirap";
  }else if(largeComp){
    pantalla = "/documentosenc";
  }
   else {
    switch (nivel) {
      case "1":
      case "2":
        // Administradores y SuperAdministradores
        pantalla = "/documentos";
        break;
      case "3":
      case "4":
        // Encargado
        pantalla = "/documentosenc";
        break;
    }
  }

  return pantalla;
};

export const getEscalaTemporal = (minutos) => {
  let data = "";
  let meses = "";
  let semanas = "";
  let dias = "";
  let horas = "";
  let min = "";

  // Meses. 1 Mes = 43200 minutos
  if (minutos >= 43200) {
    data =
      Math.floor(minutos / 43200) == 1
        ? `${Math.floor(minutos / 43200)} mes`
        : Math.floor(minutos / 43200) > 1
          ? `${Math.floor(minutos / 43200)} meses`
          : "";
    minutos = minutos % 43200;
  }
  // Semanas 1 Semana = 10080 minutos
  if (minutos >= 10080) {
    semanas =
      Math.floor(minutos / 10080) == 1
        ? `${Math.floor(minutos / 10080)} semana`
        : Math.floor(minutos / 10080) > 1
          ? `${Math.floor(minutos / 10080)} semanas`
          : "";
    minutos = minutos % 10080;
    if (data != "") {
      data += `, ${semanas}`;
    } else {
      data = semanas;
    }
  }
  // Días 1 Día = 1440 minutos
  if (minutos >= 1440) {
    dias =
      Math.floor(minutos / 1440) == 1
        ? `${Math.floor(minutos / 1440)} día`
        : Math.floor(minutos / 1440) > 1
          ? `${Math.floor(minutos / 1440)} días`
          : "";
    minutos = minutos % 1440;
    if (data != "") {
      data += `, ${dias}`;
    } else {
      data = dias;
    }
  }
  // Horas 1 Hora = 60 minutos
  if (minutos >= 60) {
    horas =
      Math.floor(minutos / 60) == 1
        ? `${Math.floor(minutos / 60)} hora`
        : Math.floor(minutos / 60) > 1
          ? `${Math.floor(minutos / 60)} horas`
          : "";
    minutos = minutos % 60;
    if (data != "") {
      data += `, ${horas}`;
    } else {
      data = horas;
    }
  }
  // Minutos
  min =
    minutos == 1
      ? `${minutos} minuto`
      : minutos > 1
        ? `${minutos} minutos`
        : "";
  if (data != "") {
    if (min != "") {
      data += `, ${min}`;
    } else {
      data += min;
    }
  } else {
    data = min;
  }

  return data;
};

export const replaceTextosAlarmas = (
  texto,
  centroVar,
  equipoVar,
  variableVar,
  condicionVar,
  intervaloVar,
  nivelVar,
  destinatariosVar,
  refsupinfVar,
  rangoMinVar,
  rangoMaxVar,
) => {
  texto = centroVar != "" ? MiReplaceAll(texto, "%CEN%", centroVar) : texto;
  texto = equipoVar != "" ? MiReplaceAll(texto, "%EQU%", equipoVar) : texto;
  texto = variableVar != "" ? MiReplaceAll(texto, "%VAR%", variableVar) : texto;
  texto =
    condicionVar != "" ? MiReplaceAll(texto, "%CON%", condicionVar) : texto;
  texto =
    intervaloVar != ""
      ? MiReplaceAll(texto, "%EST%", getEscalaTemporal(intervaloVar))
      : texto;
  texto =
    intervaloVar != "" ? MiReplaceAll(texto, "%TIM%", intervaloVar) : texto;
  texto = nivelVar != "" ? MiReplaceAll(texto, "%LVL%", nivelVar) : texto;
  texto =
    destinatariosVar != ""
      ? MiReplaceAll(texto, "%DES%", destinatariosVar)
      : texto;
  texto =
    refsupinfVar != "" ? MiReplaceAll(texto, "%REF%", refsupinfVar) : texto;
  texto = rangoMinVar != "" ? MiReplaceAll(texto, "%MIN%", rangoMinVar) : texto;
  texto = rangoMaxVar != "" ? MiReplaceAll(texto, "%MAX%", rangoMaxVar) : texto;

  return texto;
};

export const setStockOptionsSelectUbi = (options) => {
  let newOptions = [];
  if (options) {
    newOptions = options.map((opt, index) => {
      let color = opt.act > 0 ? "text-success" : "text-danger";
      return {
        value: opt.value,
        label:
          opt.act != null ? (
            <div>
              <span
                className={color + " text-right"}
                style={{
                  width: "60px",
                  display: "inline-block",
                  backgroundColor: "rgb(242, 242, 242)",
                  borderRadius: "3px",
                  paddingRight: "5px",
                  marginRight: "5px",
                }}>
                {opt.act} u
              </span>
              <span>{opt.label}</span>
            </div>
          ) : (
            <div>
              <span
                className={"text-danger text-right"}
                style={{
                  width: "60px",
                  display: "inline-block",
                  backgroundColor: "rgb(242, 242, 242)",
                  borderRadius: "3px",
                  paddingRight: "5px",
                  marginRight: "5px",
                }}>
                0 u
              </span>
              <span>{opt.label}</span>
            </div>
          ),
      };
    });
  }

  return newOptions;
};

export const setStockOptionsSelectUbiLarge = (options) => {
  let newOptions = [];
  if (options) {
    newOptions = options.map((opt, index) => {
      // Verificar si opt.label no es un string
      if (typeof opt.label !== "string") {
        return opt;
      }

      // Verificar si el label contiene \n o \r, si no, devolverlo tal cual
      if (
        typeof opt.label == "string" &&
        !opt.label.includes("\n") &&
        !opt.label.includes("\r")
      ) {
        return {
          value: opt.value,
          label: opt.label,
        };
      }

      // Separar el label en líneas por el separador \r\n
      let labelParts = opt.label.split("\r\n").map((part, index) => {
        return part.replace(/\((\-?\d+)\)/g, (match, number) => {
          let numColor = number >= 0 ? "text-success" : "text-danger";
          return `<span 
                            class="${numColor}"
                            style="
                                width: 55px;
                                display: inline-block;
                                background-color: rgb(225, 222, 222);
                                border-radius: 3px;
                                padding-right: 5px;
                                margin-right: 5px;
                                text-align: right
                            "
                            >
                                ${number}
                            </span>`;
        });
      });

      return {
        value: opt.value,
        label: (
          <div>
            <div>
              {labelParts.map((part, idx) =>
                idx === 0 ? (
                  <div
                    key={idx}
                    style={{ margin: "0px 0px -9px 0px", padding: "0px" }}
                    dangerouslySetInnerHTML={{ __html: part }}
                  />
                ) : (
                  <small
                    className="font-italic"
                    style={{ margin: "0px", padding: "5px 0px 0px 0px" }}
                    key={idx}
                    dangerouslySetInnerHTML={{ __html: part }}
                  />
                ),
              )}
            </div>
          </div>
        ),
      };
    });
  }

  return newOptions;
};

export const getStockOptionsSelectUbi = async (
  optionselectubi,
  iduni,
  saveLoading = null,
) => {
  if (saveLoading) {
    saveLoading(true);
  }

  const data = new FormData();
  data.append(
    "validacion",
    JSON.stringify({
      sesion: getDecodedCookie("sesion"),
      id: getDecodedCookie("id"),
    }),
  );
  data.append("options", JSON.stringify(optionselectubi));
  data.append("iduni", iduni);

  const respuesta = await axios.post(
    getApiUrl(window.location.origin) + "/ubicaciones/getStockUniFromUbi",
    data,
  );

  if (saveLoading) {
    saveLoading(false);
  }

  return respuesta.data;
};

export const getNumFromData = (data, color) => {
  return (
    <span className="pr-2">
      <strong
        style={{
          // border : "1px solid",
          padding: "1px 6px 1px 6px",
          borderRadius: "5px",
          fontSize: "1.1em",
        }}>
        {data.filter((elemento) => elemento.style === color).length}
      </strong>
    </span>
  );
};

export const getNumFromDataTraPdtAsignar = (
  data,
  searchExce,
  strong = true,
) => {
  if (strong == true) {
    if (searchExce) {
      return (
        <span className="pr-2">
          <strong
            style={{
              // border : "1px solid",
              padding: "1px 6px 1px 6px",
              borderRadius: "5px",
              fontSize: "1.1em",
            }}>
            {
              data.filter(
                (elemento) =>
                  elemento.horas !== "" && elemento.horas.includes("EXCE_"),
              ).length
            }
          </strong>
        </span>
      );
    } else {
      return (
        <span className="pr-2">
          <strong
            style={{
              // border : "1px solid",
              padding: "1px 6px 1px 6px",
              borderRadius: "5px",
              fontSize: "1.1em",
            }}>
            {
              data.filter(
                (elemento) =>
                  elemento.horas !== "" && !elemento.horas.includes("EXCE_"),
              ).length
            }
          </strong>
        </span>
      );
    }
  } else {
    if (searchExce) {
      return data.filter(
        (elemento) => elemento.horas !== "" && elemento.horas.includes("EXCE_"),
      ).length;
    } else {
      return data.filter(
        (elemento) =>
          elemento.horas !== "" && !elemento.horas.includes("EXCE_"),
      ).length;
    }
  }
};

export const getNotasWizard = (notas, notas_en, margin = "") => {
  let notasRender = null;

  if (getDecodedCookie("idioma") == "es" && notas != "") {
    notasRender = (
      <div
        className={margin + " col-12 pl-2"}
        style={{ whiteSpace: "pre-line" }}>
        {notas}
      </div>
    );
  } else if (getDecodedCookie("idioma") == "en" && notas_en != "") {
    notasRender = (
      <div
        className={margin + " col-12 pl-2"}
        style={{ whiteSpace: "pre-line" }}>
        {notas_en}
      </div>
    );
  }

  return notasRender;
};

export const getDatePickerDaysName = () => {
  const idiomoaUsu = getDecodedCookie("idioma");

  if (idiomoaUsu && idiomoaUsu.toLowerCase() == "es") {
    return {
      sunday: "Do",
      monday: "Lu",
      tuesday: "Ma",
      wednesday: "Mi",
      thursday: "Ju",
      friday: "Vi",
      saturday: "Sa",
      ok: "OK",
      today: "Hoy",
      yesterday: "Ayer",
      hours: "Horas",
      minutes: "Minutos",
      seconds: "Segundos",
    };
  } else if (idiomoaUsu && idiomoaUsu.toLowerCase() == "en") {
    return {
      sunday: "Su",
      monday: "Mo",
      tuesday: "Tu",
      wednesday: "We",
      thursday: "Th",
      friday: "Fr",
      saturday: "Sa",
      ok: "OK",
      today: "Today",
      yesterday: "Yesterday",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
    };
  } else {
    return {
      sunday: "Do",
      monday: "Lu",
      tuesday: "Ma",
      wednesday: "Mi",
      thursday: "Ju",
      friday: "Vi",
      saturday: "Sa",
      ok: "OK",
      today: "Hoy",
      yesterday: "Ayer",
      hours: "Horas",
      minutes: "Minutos",
      seconds: "Segundos",
    };
  }
};

export const decryptData = async (
  encryptedData,
  cryptMode,
  forceDecrypt = false,
) => {
  if (cryptMode == "1" || forceDecrypt == true) {
    // Parsear los datos recibidos
    const password = getPassWord();
    const decodedData = JSON.parse(atob(encryptedData));
    const ciphertext = base64ToArrayBuffer(decodedData.ciphertext);
    const iv = base64ToArrayBuffer(decodedData.iv);
    const salt = base64ToArrayBuffer(decodedData.salt);
    const tag = base64ToArrayBuffer(decodedData.tag);
    const iterations = decodedData.iterations;

    // Derivar clave usando PBKDF2
    const encoder = new TextEncoder();
    const keyMaterial = await window.crypto.subtle.importKey(
      "raw",
      encoder.encode(password),
      { name: "PBKDF2" },
      false,
      ["deriveKey"],
    );

    const key = await window.crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: salt,
        iterations: iterations,
        hash: "SHA-256",
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      false,
      ["decrypt"],
    );

    // Desencriptar
    const decrypted = await window.crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
        additionalData: new Uint8Array([]),
        tagLength: 128,
      },
      key,
      concatenateBuffers(ciphertext, tag),
    );

    const decoder = new TextDecoder();
    return decoder.decode(decrypted);
  } else {
    return encryptedData;
  }
};

export const encryptData = async (data, cryptMode) => {
  if (cryptMode == "1") {
    const password = getPassWord();

    // Generar sal para PBKDF2
    const salt = window.crypto.getRandomValues(new Uint8Array(16));

    // Generar IV para AES-GCM
    const iv = window.crypto.getRandomValues(new Uint8Array(12));

    // Derivar clave usando PBKDF2
    const encoder = new TextEncoder();
    const keyMaterial = await window.crypto.subtle.importKey(
      "raw",
      encoder.encode(password),
      { name: "PBKDF2" },
      false,
      ["deriveKey"],
    );
    const iterations = 100000;
    const key = await window.crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: salt,
        iterations: iterations,
        hash: "SHA-256",
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      false,
      ["encrypt"],
    );

    // Encriptar los datos
    const encodedData = encoder.encode(data);
    const encrypted = await window.crypto.subtle.encrypt(
      {
        name: "AES-GCM",
        iv: iv,
        additionalData: new Uint8Array([]),
        tagLength: 128,
      },
      key,
      encodedData,
    );

    // Separar el tag del ciphertext
    const ciphertext = encrypted.slice(0, -16);
    const tag = encrypted.slice(-16);

    // Codificar en base64 para transmitir
    const base64Ciphertext = arrayBufferToBase64(ciphertext);
    const base64Iv = arrayBufferToBase64(iv);
    const base64Salt = arrayBufferToBase64(salt);
    const base64Tag = arrayBufferToBase64(tag);

    return btoa(
      JSON.stringify({
        ciphertext: base64Ciphertext,
        iv: base64Iv,
        salt: base64Salt,
        tag: base64Tag,
        iterations: iterations,
      }),
    );
  } else {
    return data;
  }
};

const getPassWord = () => {
  // Obtener el referer de la solicitud
  var referer = window.location.hostname;

  // Eliminar el protocolo (http, https, etc.) del referer
  referer = referer.replace(/^(http:\/\/|https:\/\/)/, "");

  // Convertir a minúsculas y eliminar caracteres que no sean letras de la a a la z
  var refererFiltrado = referer.toLowerCase().replace(/[^a-z]/g, "");

  // Contar vocales y consonantes
  var vocales = (refererFiltrado.match(/[aeiou]/g) || []).length;
  var consonantes = (refererFiltrado.match(/[bcdfghjklmnpqrstvwxyz]/g) || [])
    .length;

  // Añadir números de vocales y consonantes al final del string modificado
  var resultadoFinal = refererFiltrado + vocales + consonantes;

  return resultadoFinal;
};

const ensureLength = (input, length) => {
  const caracteresAleatorios = "abcdefghijklmnopqrstuvwxyz0123456789";
  let resultado = input;
  while (resultado.length < length) {
    const randomIndex = Math.floor(Math.random() * caracteresAleatorios.length);
    resultado += caracteresAleatorios.charAt(randomIndex);
  }
  return resultado;
};

const secretKey = ensureLength(getPassWord(), 32); // Asegurar que la clave tiene 32 caracteres
const iv = ensureLength(getPassWord(), 16); // Asegurar que el IV tiene 16 caracteres

const encrypt = (data) => {
  const cipher = CryptoJS.AES.encrypt(
    data,
    CryptoJS.enc.Utf8.parse(secretKey),
    { iv: CryptoJS.enc.Utf8.parse(iv) },
  );
  return cipher.ciphertext.toString(CryptoJS.enc.Hex);
};
const decrypt = (ciphertext) => {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(ciphertext);
  const bytes = CryptoJS.AES.decrypt(
    {
      ciphertext: encryptedHexStr,
      salt: "",
      iv: CryptoJS.enc.Utf8.parse(iv),
      key: CryptoJS.enc.Utf8.parse(secretKey),
    },
    CryptoJS.enc.Utf8.parse(secretKey),
    { iv: CryptoJS.enc.Utf8.parse(iv) },
  );
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const setEncodedCookie = (key, value, options) => {
  const cookies = new Cookies();

  // const encodedKey = encrypt(key);
  // const encodedValue = encrypt(value);
  // cookies.set(encodedKey, encodedValue, options);
  cookies.set(key, value, options);
};

export const getDecodedCookie = (key) => {
  const cookies = new Cookies();

  // const encodedKey = encrypt(key);
  // const encodedValue = cookies.get(encodedKey);
  // return encodedValue ? decrypt(encodedValue) : null;
  return cookies.get(key);
};

export const removeEncodedCookie = (key, options) => {
  const cookies = new Cookies();

  // const encodedKey = encrypt(key);
  // cookies.remove(encodedKey, options);
  cookies.remove(key, options);
};

export const getCookieOptions = () => {
  // Fecha actual
  const now = new Date();

  // Calcular fecha de expiración (1 mes a partir de ahora)
  const expirationDate = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);

  // Configuración común para todas las cookies
  const cookieOptions = {
    path: "/",
    expires: expirationDate,
    secure: true,
    // domain: window.location.hostname,
    sameSite: "lax",
  };

  return cookieOptions;
};

export const helperSetCookiesLogin = (usuario) => {
  setEncodedCookie("id", usuario.id, getCookieOptions());
  setEncodedCookie("email", usuario.email, getCookieOptions());
  setEncodedCookie("nombre", usuario.nombre, getCookieOptions());
  setEncodedCookie("sesion", usuario.sesion, getCookieOptions());
  setEncodedCookie("nivel", usuario.nivel, getCookieOptions());
  setEncodedCookie("estado", usuario.estado, getCookieOptions());
  setEncodedCookie("idioma", usuario.idioma.toLowerCase(), getCookieOptions());
  setEncodedCookie("imguser", usuario.imguser, getCookieOptions());
  setEncodedCookie("idage", usuario.idage, getCookieOptions());
};

export const helperDeleteCookiesLogin = () => {
  removeEncodedCookie("id", getCookieOptions());
  removeEncodedCookie("email", getCookieOptions());
  removeEncodedCookie("nombre", getCookieOptions());
  removeEncodedCookie("sesion", getCookieOptions());
  removeEncodedCookie("nivel", getCookieOptions());
  removeEncodedCookie("estado", getCookieOptions());
  removeEncodedCookie("idioma", getCookieOptions());
  removeEncodedCookie("imguser", getCookieOptions());
  removeEncodedCookie("idage", getCookieOptions());
  removeEncodedCookie("intervalo", getCookieOptions());
  removeEncodedCookie("kpiIni", getCookieOptions());
  removeEncodedCookie("kpiFin", getCookieOptions());
  removeEncodedCookie("defaultActiveKey", getCookieOptions());
  removeEncodedCookie("defaultActiveKeyCheckList", getCookieOptions());
  removeEncodedCookie("filterRegs", getCookieOptions());
  removeEncodedCookie("nomage", getCookieOptions());
};

const base64ToArrayBuffer = (base64) => {
  const binaryString = atob(base64);
  const length = binaryString.length;
  const bytes = new Uint8Array(length);
  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

const concatenateBuffers = (buffer1, buffer2) => {
  const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
  tmp.set(new Uint8Array(buffer1), 0);
  tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
  return tmp.buffer;
};

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

export const btnsImportExportFile = (
  saveLoadingTable,
  traduction,
  fileInputRef,
  botones,
  idTabla,
  data,
  idReg = null,
) => {
  // Para que funcione meter en las tablas después de </table>:
  //    <input
  //         id="importFileToBBDD"
  //         type="file"
  //         ref={fileInputRef}
  //         style={{ display: 'none' }}
  //         accept=".xls,.xlsx"
  //         onChange={ e => importFileToBBDD(saveLoadingTable, traduction, id, fnReloadTable, null, idRegImportExport)}
  //     />
  // Importar en la tabla: useRef -> Ejemplo: import React, { useEffect, useState, Fragment, useRef } from 'react';
  // Pasar en los componentes MiDataTable... los parámetros:
  //      -importExportFile={true}
  //      -fnReloadTable={fn: editarLineas, key: "iddoc"} -> Objeto con a función que recarga los datos de la tabla(clave -> fn) y nombre de la clave que sen envía en la función de recarga(clave -> key). En importFileToBBDD al método que recarga la tabla se le pasa un objeto así {id:idReg}, mirar que la función que recarga la clave que se envía para recargar se llame id.
  //      -idRegImportExport -> Id de registro en caso de que la importación/exportación se haga sobre un registro concreto
  //      -saveLoadingTable=State que meneje un spinner
  // Importar en los componentes MiDataTable... los métodos desde helperApp:
  //      btnsImportExportFile -> Es este método
  //      importFileToBBDD -> Método para abrir el input y mandar los datos al api para que los guarde en la bbdd
  // Meter este código en la tabla
  // if( importExportFile == true){
  //     botones = [...botones];
  //     botones = btnsImportExportFile(saveLoadingTable, traduction, fileInputRef, botones, fnReloadTable, id, data, idRegImportExport);
  // }

  const btnExportFile = {
    text: `<i style='font-size: 20px;' class='fal fa-upload'></i>`,
    className: "btn btn-flat mr-1 btn-outline-secondary btnExportFile",
    extend: "excelHtml5",
    exportOptions: {
      columns: ":all", // Exportamos todas las columnas, visibles y no visibles
      // columns: [0, 1, 3] // exporta solo las columnas 0, 1 y 3
    },
    action: function () {
      exportDataToFile(saveLoadingTable, traduction, idTabla, data, idReg);
    },
  };
  // Elimina el botón de exportación si ya existe
  botones = botones.filter(
    (boton) =>
      !(
        boton.text === btnExportFile.text &&
        boton.className === btnExportFile.className
      ),
  );

  // Añade el botón de exportación
  botones.push(btnExportFile);

  const btnImportFile = {
    text: `<i style='font-size: 20px;' class='fal fa-download'></i>`,
    className: "btn btn-flat mr-1 btn-outline-secondary btnImportFile",
    extend: "excelHtml5",
    exportOptions: {
      columns: ":all", // Exportamos todas las columnas, visibles y no visibles
      // columns: [0, 1, 3] // exporta solo las columnas 0, 1 y 3
    },
    action: function () {
      // Activa el input de archivo oculto
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    },
  };

  // Elimina el botón de importación si ya existe
  botones = botones.filter(
    (boton) =>
      !(
        boton.text === btnImportFile.text &&
        boton.className === btnImportFile.className
      ),
  );

  // Añade el botón de importación
  botones.push(btnImportFile);

  return botones;
};

const exportDataToFile = async (
  saveLoadingTable,
  traduction,
  idTabla,
  data,
  idReg = null,
) => {
  if (saveLoadingTable) {
    saveLoadingTable(true);
  }

  const formData = new FormData();
  formData.append(
    "validacion",
    JSON.stringify({
      sesion: getDecodedCookie("sesion"),
      id: getDecodedCookie("id"),
    }),
  );
  formData.append("data", JSON.stringify(data));
  formData.append("case", idTabla);
  formData.append("idreg", idReg);

  const respuesta = await axios.post(
    getApiUrl(window.location.origin) + "/app/generaxls",
    formData,
  );
  if (respuesta.data.error != "") {
    swal({
      title: traduction.importexportfile.errorfile.title,
      text: "",
      icon: "error",
      buttons: {
        cancel: {
          text: traduction.importexportfile.btncerrar.title,
          className: "btn btnSwalDelete btn-flat mr-1 btn-outline-danger",
          visible: true,
        },
      },
    });
  } else {
    // Obtener el nombre del fichero desde la URL
    const fileUrl = respuesta.data.path;
    const fileName = fileUrl.split("/").pop();

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  if (saveLoadingTable) {
    saveLoadingTable(false);
  }
};

export const importFileToBBDD = async (
  saveLoadingTable,
  traduction,
  idTabla,
  fnReloadTable,
  idReg = null,
  e = null,
) => {
  if (saveLoadingTable) {
    saveLoadingTable(true);
  }

  let file = null;
  if (e != null) {
    file = e.target.files[0];
    // Reiniciamos el input para permitir volver a seleccionar el mismo archivo
    e.target.value = "";
  } else {
    const inputFile = document.getElementById("importFileToBBDD");
    file = inputFile?.files?.[0];
    // Reinicia el input para permitir volver a adjuntar el mismo archivo
    inputFile.value = "";
  }

  const formData = new FormData();
  formData.append(
    "validacion",
    JSON.stringify({
      sesion: getDecodedCookie("sesion"),
      id: getDecodedCookie("id"),
    }),
  );
  formData.append("case", idTabla);
  formData.append("idreg", idReg);
  formData.append("file", file);

  const respuesta = await axios.post(
    getApiUrl(window.location.origin) + "/app/importarxls",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  if (respuesta.data.error != "") {
    swal({
      title: traduction.importexportfile.errorimport.title,
      text: "",
      icon: "error",
      buttons: {
        cancel: {
          text: traduction.importexportfile.btncerrar.title,
          className: "btn btnSwalDelete btn-flat mr-1 btn-outline-danger",
          visible: true,
        },
      },
    });
  } else {
    // Recarga la tabla
    if (idReg != null) {
      await fnReloadTable.fn({ [fnReloadTable.key]: idReg });
    } else {
      await fnReloadTable.fn();
    }

    swal({
      title: traduction.importexportfile.okimport.title,
      text: "",
      icon: "success",
      buttons: {
        cancel: {
          text: traduction.importexportfile.btncerrar.title,
          className: "btn btnSwalDelete btn-flat mr-1 btn-outline-danger",
          visible: true,
        },
      },
    });
  }

  if (saveLoadingTable) {
    saveLoadingTable(false);
  }
};

export const importExcel = (e, data, saveData, traduction, origen) => {
  const file = e.target.files[0];
  // Reiniciamos el input para permitir volver a seleccionar el mismo archivo
  e.target.value = "";

  if (!file) {
    swal({
      title: traduction.importadorexcel.nofile.title,
      text: "",
      icon: "error",
      buttons: {
        cancel: {
          text: traduction.importadorexcel.btncerrar.title,
          className: "btn btn-flat mr-1 btn-outline-secondary",
          visible: true,
        },
      },
    });
    return;
  }

  // Validar que se trate de un archivo Excel (.xls o .xlsx)
  const allowedExtensions = /(\.xls|\.xlsx)$/i;
  if (!allowedExtensions.exec(file.name)) {
    alert(traduction.importadorexcel.errorext.title);
    return;
  }

  const reader = new FileReader();

  reader.onload = (event) => {
    try {
      const dataAux = event.target.result;
      // Lee el libro Excel como binario
      const workbook = XLSX.read(dataAux, { type: "binary" });
      // Obtiene la primera hoja
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      /* 
          Suponiendo que el Excel tiene la siguiente estructura:
          - Fila 1: Información (fecha) a ignorar
          - Fila 2: Cabeceras (keys) que nos interesan
          - Fila 3 en adelante: Datos

          La opción "range: 1" indica que se salte la primera fila (índice 0)
          y que la fila siguiente (índice 1, es decir, la Fila 2 del Excel)
          se utilice como cabecera.
        */
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        range: 1,
        defval: "",
      });

      // Clonamos el array de data y creamos nuevos objetos para evitar la mutación directa
      const datosAux = data.map((row) => ({ ...row }));

      for (let i = 0; i < datosAux.length; i++) {
        if (origen == "request/midatatablelineas") {
          datosAux[i].fec2 = jsonData[i]?.FechaP
            ? excelDateToJSDate(jsonData[i]?.FechaP)
            : datosAux[i].fec2;
          datosAux[i].cantidad = jsonData[i]?.Cantidad || datosAux[i].cantidad;
          datosAux[i].coste = jsonData[i]?.Coste || datosAux[i].coste;
          datosAux[i].notaslinea = jsonData[i]?.Notas || datosAux[i].notaslinea;
        }
        if (origen == "edirap/midatatableedirap") {
          datosAux[i].cantidad = jsonData[i]?.Cantidad || datosAux[i].cantidad;
        }
        if (origen == "largeinv/midatatablelarge") {
          datosAux[i].cantidad = jsonData[i]?.Cantidad || datosAux[i].cantidad;
        }
      }

      // Guarda el nuevo array en el estado para que React detecte el cambio
      saveData(datosAux);
    } catch (err) {
      alert(traduction.importadorexcel.errorext.title);
    }
  };

  reader.onerror = () => {
    alert(traduction.importadorexcel.errorext.title);
  };

  // Lee el archivo como cadena binaria
  reader.readAsBinaryString(file);
};

const excelDateToJSDate = (serial) => {
  const excelEpoch = new Date(1900, 0, 1); // 1 de enero de 1900
  const daysOffset = serial - 1; // Ajuste porque Excel empieza el 1/1/1900 como día 1 y hay un bug con 1900 como año bisiesto
  const date = new Date(excelEpoch.setDate(excelEpoch.getDate() + daysOffset));
  return date.toISOString().split("T")[0];
};

export const getNumNoLeidosExcedidos = (mantenimientos) => {  
  if (!Array.isArray(mantenimientos.data)) return 0;
  const ahora = getAhorayyyymmdd();
  return mantenimientos.data.reduce((count, item) => {    
    if (
      item.exp_date <= ahora &&
      (item.noleido === false || item.noleido === "false")
    ) {
      return count + 1;
    }
    return count;
  }, 0);
};

export const getNumNoLeidosEnPlazo = (mantenimientos) => {
  if (!Array.isArray(mantenimientos.data)) return 0;
  const ahora = getAhorayyyymmdd();
  return mantenimientos.data.reduce((count, item) => {
    if (
      item.exp_date > ahora &&
      (item.noleido === false || item.noleido === "false")
    ) {
      return count + 1;
    }
    return count;
  }, 0);
};

export const handleOpenMenu = (
  e,
  indice,
  saveOpen,
  mapNav = false,
  propiedades,
) => {
  if (e && e.target && e.target.classList.contains("menuCustomNoLink")) {
    return;
  }
  const url = window.location;
  const menus = document.querySelectorAll(".menuSup");
  const botonesMapNav = document.querySelectorAll(".btnMapNav");
  botonesMapNav.forEach((boton) => {
    boton.classList.remove("active");
  });

  for (let i = 0; i < menus.length; i++) {
    if (mapNav == true) {
      if (menus[i].id == "menuSup" + indice) {
        const btnMapNav = document.getElementById("btnMapNav-" + indice);
        btnMapNav.classList.add("active");
        menus[i].children[0].classList.toggle("active");
        menus[i].classList.toggle("menu-open");

        if (menus[i].classList.contains("menu-open")) {
          menus[i].classList.remove("noDisplay");

          // Los demás se ocultan
          for (let j = 0; j < menus.length; j++) {
            if (j !== i) {
              menus[j].children[0].classList.remove("active");
              menus[j].classList.remove("menu-open");
              menus[j].classList.add("noDisplay");
            }
          }
        } else {
          btnMapNav.classList.remove("active");
          // Si se cerró, TODOS los menús se muestran (sin noDisplay)
          for (let j = 0; j < menus.length; j++) {
            menus[j].classList.remove("noDisplay");
            menus[j].children[0].classList.remove("active");
            menus[j].classList.remove("menu-open");
          }
        }
      }
    } else {
      if (menus[i].id == "menuSup" + indice) {
        if (e == null) {
          menus[i].children[0].classList.toggle("active");
          menus[i].classList.add("menu-open");
          if (menus[i].children.length > 1) {
            if (
              document.querySelector("#" + menus[i].children["sub" + indice].id)
            ) {
              const subMenu = document.querySelector(
                "#" + menus[i].children["sub" + indice].id,
              );
              if (subMenu) {
                for (let i = 0; i < subMenu.children.length; i++) {
                  // if(propiedades && Object.keys(propiedades).length > 0  && propiedades.props?.location.state){
                  if (
                    propiedades &&
                    Object.keys(propiedades).length > 0 &&
                    propiedades.props?.location.pathname
                  ) {
                    // if( subMenu.children[i].children[0].dataset.href == url.pathname+"/"+propiedades.props.location.state.filter ){
                    if (
                      subMenu.children[i].children[0].dataset.href ==
                      url.pathname
                    ) {
                      subMenu.children[i].children[0].classList.add("active");
                      subMenu.children[i].classList.toggle("active");
                    }
                  }
                }
              }
            }
          } else {
            menus[i].children[0].classList.add("active");
          }
        } else {
          menus[i].classList.toggle("menu-open");
        }
      } else {
        if (e == null) {
          menus[i].children[0].classList.remove("active");
        } else {
          // Funcionamiento acordeon. Con este código cerramos todos los menús menos en el que hacemos click
          if (!menus[i].children[0].classList.contains("active")) {
            menus[i].classList.remove("menu-open");
          }
        }
      }
    }
  }
  if (saveOpen) {
    saveOpen(indice);
  }
};

export const getNotificationsMenu = async (resMenu, saveMenuParam) => {
  if (resMenu != null) {
    let callApi = hasGetnot(resMenu);
    if (callApi) {
      const data = new FormData();
      data.append(
        "validacion",
        JSON.stringify({
          sesion: getDecodedCookie("sesion"),
          id: getDecodedCookie("id"),
        }),
      );
      data.append("menu", JSON.stringify(resMenu));
      const respuesta = await axios.post(
        getApiUrl(window.location.origin) + "/app/getNotificationsMapNav",
        data,
      );
      if (respuesta.data.error == "") {
        saveMenuParam(respuesta.data.menu);
      }
    }
  }
};

function hasGetnot(data) {
  // Usamos Array.some para detenernos en cuanto encontremos un caso válido
  return data.some((item) => {
    // Si el propio objeto tiene getnot y no está vacío
    if (item.getnot && item.getnot.trim() !== "") {
      return true;
    }

    // Si existe la clave sub y es un array
    if (Array.isArray(item.sub)) {
      return item.sub.some(
        (subItem) => subItem.getnot && subItem.getnot.trim() !== "",
      );
    }

    return false;
  });
}

export const getOptionsCboHelper = async (
  fuente,
  opcion,
  appCryptCom,
  apiKey,
  likeParam = null,
  idReg = null,
  bbdd = null,
) => {
  const cookies = new Cookies();

  let options = [];
  let url = null;
  if (fuente == "filter") {
    url = getApiUrl(window.location.origin) + "/filters/getFilter";
  } else {
    url = getApiUrl(window.location.origin) + "/app/getDataCbo";
  }

  const data = new FormData();
  data.append("validacion", apiKey());

  if (bbdd) {
    bbdd = await encryptData(bbdd, appCryptCom);
    data.append("bd", bbdd);
  }
  const idCookie = await encryptData(cookies.get("id"), appCryptCom);
  data.append("ua", idCookie);
  const nivelCookie = await encryptData(cookies.get("nivel"), appCryptCom);
  data.append("na", nivelCookie);
  if (idReg) {
    data.append("ra", idReg);
  }
  if (likeParam) {
    const like = await encryptData(likeParam, appCryptCom);
    data.append("like", like);
  }

  // Encriptamos el tag sql.
  opcion = await encryptData(opcion, appCryptCom);
  data.append(fuente, opcion);

  const respuesta = await axios.post(url, data);
  options = respuesta.data;

  return options;
};
